import React from 'react';
import { Sparkles, CheckCircle2, ArrowRight } from 'lucide-react';

const TodayAiSummary = () => {
  const points = [
    "No temperature excursions",
    "Stable cooling performance",
    "Normal operating conditions",
    "No maintenance concerns"
  ];

  return (
    <div className="w-full max-w-sm bg-white border border-gray-100 rounded-2xl p-5 font-sans shadow-[0_2px_12px_rgba(0,0,0,0.01)] flex flex-col justify-between min-h-[360px] select-none">
      <div>
        {/* Header Section Title */}
        <div className="flex items-center gap-2 mb-4">
          <Sparkles className="w-4 h-4 text-[#4F46E5]" />
          <h3 className="text-[15px] font-bold text-gray-800 tracking-tight">
            Today's AI Summary
          </h3>
        </div>

        {/* Soft Alert Status Banner Banner Box */}
        <div className="bg-[#EBF7EE] rounded-xl p-3 flex items-start gap-3 mb-5">
          <div className="w-1.5 h-1.5 bg-emerald-500 rounded-full mt-1.5 shrink-0 animate-pulse"></div>
          <div className="space-y-1">
            <h4 className="text-[13px] font-bold text-[#065F46]">
              Everything looks good!
            </h4>
            <p className="text-[11px] font-medium text-[#065F46]/90 leading-normal">
              Temperature remained within safe limits all day. No concerning patterns detected.
            </p>
          </div>
        </div>

        {/* Insights Core Bullet Checklist Point Stack */}
        <div className="space-y-3 pl-0.5">
          {points.map((text, idx) => (
            <div key={idx} className="flex items-center gap-2.5">
              <CheckCircle2 className="w-4 h-4 text-emerald-500 shrink-0" strokeWidth={2.2} />
              <span className="text-[12px] font-semibold text-gray-700">{text}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Navigation Footer */}
      <button className="w-full flex items-center justify-between text-[#0052FF] font-bold text-[12px] hover:opacity-80 transition-opacity border-t border-gray-100 pt-4 mt-6 group cursor-pointer">
        <span>View full insights</span>
        <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5" strokeWidth={2.5} />
      </button>
    </div>
  );
};

export default TodayAiSummary;
